var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item-avatar',{attrs:{"color":_vm.color}},[_c('router-link',{staticClass:"initials",attrs:{"to":{ name: 'user', params: { userId: _vm.userId }}}},[_vm._v(_vm._s(_vm.initials))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }